export const Insertion = 1
export const Deletion = 2
